import React from 'react';
import type { ProjectIdentity } from '../../../types/project';
import ClassificationBadge from '../ClassificationBadge/ClassificationBadge';
import Tooltip from '../Tooltip';

interface ProjectBadgeProps {
  project: ProjectIdentity | null | undefined;
  className?: string;
}

const ProjectBadge: React.FC<ProjectBadgeProps> = ({ project, className }) => {
  if (!project) {
    return null;
  }

  return (
    <Tooltip content={project.name}>
      <ClassificationBadge
        label={project.code}
        backgroundColor={project.colors.background}
        textColor={project.colors.text}
        className={className}
      />
    </Tooltip>
  );
};

export default ProjectBadge;
